import {
  ValidationSet,
  WithoutIncomeInterface
} from '../../../../types/interface';
import { commonValidations } from '../validations';

export const SubsidyWithoutIncomeValidationSet: ValidationSet<WithoutIncomeInterface> =
  {
    configuration_threshold_invoice:
      commonValidations.configuration_threshold_invoice,
    support_provided: commonValidations.support_provided,
    maximum_support_provided_per_child: [],
    maximum_support_provided_per_user_per_year: []
  };
